import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { SignupService } from './signup.service';
import { WatcherService } from './watcher.service';

@Injectable({
  providedIn: 'root',
})
export class SEOService {
  hostCountriesCount = Number(localStorage.getItem('hostCountriesCount')) ?? 40;
  constructor(
    private title: Title,
    private meta: Meta,
    @Inject(DOCUMENT) private document: any,
    private router: Router,
    private _route: ActivatedRoute,
    private signupService: SignupService,
    private watcherService: WatcherService
  ) {
    this.hostCountriesCount = Number(
      localStorage.getItem('hostCountriesCount')
    );
    if (!this.hostCountriesCount) {
      this.signupService.getHostCountries().subscribe((list) => {
        this.hostCountriesCount = list['data'].length;
      });
    }
    this.watcherService.getLang().subscribe((lang: string) => {
      this.lang = lang;
    });
  }
  lang: string = 'en';
  langs: string[] = [
    'en',
    'fr',
    'de',
    'it',
    'he',
    'ar',
    'zh-CN',
    'es',
    'ru',
    'pt',
    'id',
    'ja',
    'ms',
    'sv',
    'no',
    'nl',
  ];
  createCanonicalUrl() {
    this.destroyLinkForCanonicalURL();
    let urlParts = this.document.URL.split('/');
    let newLink = urlParts.join('/');
    let link: HTMLLinkElement = this.document.createElement('link');
    link.setAttribute('rel', 'canonical');
    link.setAttribute('href', newLink);
    this.document.head.appendChild(link);
  }
  destroyLinkForCanonicalURL() {
    const els = this.document.querySelectorAll("link[rel='canonical']");
    if (els) {
      for (let i = 0, l = els.length; i < l; i++) {
        const el = els[i];
        el.remove();
      }
    } else {
      return;
    }
  }
  createMapsScript() {
    // if (window.document.getElementById('mapsScript')) {
    //     return;
    // } else {
    //     const mapsScript = "https://maps.googleapis.com/maps/api/js?key=AIzaSyBgm0AbeCNUr-VgD93TcZTVZ_3Z-VZB5nI&libraries=places&language=en&callback=Function.prototype";
    //     const scriptEl = window.document.createElement('script');
    //     scriptEl.src = mapsScript;
    //     scriptEl.id = 'mapsScript';
    //     scriptEl.defer = true;
    //     window.document.body.appendChild(scriptEl);
    // }
  }
  createHrefLangs() {
    this.destroyHrefLangs();
    const url = this.router.url;
    let urlParts = url.split('/');
    let routelang = urlParts[1];
    for (let index = 0; index < this.langs.length; index++) {
      let lang = this.langs[index];
      if (lang == 'he') {
        lang = 'iw';
      }
      urlParts[1] = lang;
      let alternateRouteUrl = urlParts.join('/');
      let alternateURL =
        'https://' + this.document.location.hostname + alternateRouteUrl;
      let linkHrefLang: HTMLLinkElement = this.document.createElement('link');
      linkHrefLang.setAttribute('rel', 'alternate');
      linkHrefLang.setAttribute('hreflang', lang);
      linkHrefLang.setAttribute('href', alternateURL);
      this.document.head.appendChild(linkHrefLang);
    }
    urlParts[1] = 'en';
    let xdefaultUrl = urlParts.join('/');
    let xdefault: HTMLLinkElement = this.document.createElement('link');
    xdefault.setAttribute('rel', 'alternate');
    xdefault.setAttribute('hreflang', 'x-default');
    xdefault.setAttribute(
      'href',
      'https://' + this.document.location.hostname + xdefaultUrl
    );
    this.document.head.appendChild(xdefault);
  }

  destroyHrefLangs() {
    const els = this.document.querySelectorAll("link[rel='alternate']");
    for (let i = 0, l = els.length; i < l; i++) {
      const el = els[i];
      el.remove();
    }
  }

  createOrganizationSchema() {
    if (window.document.getElementById('organizationSchema')) {
      return;
    } else {
      const organizationSchema = {
        '@context': 'https://schema.org',
        '@type': 'Organization',
        url: 'https://www.shippn.com/en/home',
        logo: {
          '@type': 'ImageObject',
          url: 'https://d1we2hgzmci25y.cloudfront.net/assets/img/shippn-logo-black.webp',
          width: 199,
          height: 47,
        },
        image:
          'https://d1we2hgzmci25y.cloudfront.net/assets/img/shippn-logo-black.webp',
        name: 'Shippn',
        description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
        address: {
          '@type': 'PostalAddress',
          streetAddress: '8 The Green Ste 4000',
          addressLocality: 'Dover',
          addressRegion: 'DE',
          postalCode: '19901',
          addressCountry: 'US',
        },
        email: 'help@shippn.com',
        telephone: '1-740-848-5020',
        sameAs: [
          'https://www.instagram.com/shippncom/',
          'https://www.facebook.com/shippn',
          'https://x.com/shippncom',
          'https://www.linkedin.com/company/shippn/',
        ],
        vatID: '92-0528434',
      };
      const scriptEl = window.document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.innerHTML = JSON.stringify(organizationSchema);
      scriptEl.id = 'organizationSchema';
      window.document.head.appendChild(scriptEl);
    }
  }

  removeOrganizationSchema() {
    const organizationSchemaScript =
      window.document.getElementById('organizationSchema');

    if (organizationSchemaScript) {
      window.document.head.removeChild(organizationSchemaScript);
    }
  }
  createReviewsSchema() {
    if (window.document.getElementById('reviewsScript')) {
      return;
    } else {
      const reviewsData = [
        {
          '@context': 'https://schema.org/',
          '@type': 'AggregateRating',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image:
              'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          ratingValue: '5',
          reviewCount: '7',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image:
              'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Nicholas',
          },
          reviewBody:
            "I didn't know such a service existed and when I found it, I was skeptical at first. But the whole process was seamless, the website was clear and informative and Stanislav (who collected and shipped the items) kept me up to date on every step. Got here quickly too. Very satisfied!",
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image:
              'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Anita',
          },
          reviewBody:
            "I'm a collector of a particular brand of product from around the world. Since discovering shippn two months ago, I've been able to shop for my favorite things in new markets such as Australia and South Africa. I've placed three orders with Shippn so far, and the fragile and hard to find items have all reached me quickly and in perfect condition. I've worked with two separate hosts on the three orders and both were a pleasure to work with and very responsive.",
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/belgium.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'A. Brahm',
          },
          reviewBody:
            "This is my 3rd experience with Shipping and it went marvelously as it was the case for my two former experiences with them. I trusted in the same host -- Mr. Kelby Cody -- and I'm so happy to have met him as a host. Kelby is such a great guy you can trust in. He always does the right thing, the fast and easy way. Kelby never forgets to get you updated about what's going on with your purchase. I really recommend Kelby and of course Shippn.",
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/united-kingdom.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Elaine',
          },
          reviewBody:
            'I was a little dubious to start with. But I could not find the item I wanted anywhere but Australia and they would not deliver to the UK. So I tried this service, fantastic. They kept me updated all the way through and I received my item in less than 2 weeks. I would definitely use them again.',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/germany.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Daniil',
          },
          reviewBody:
            'Absolutely great experience, top service - the best customer experience i have ever had. I came to Shippn with a very difficult task, to secure an expensive (4000 USD) high demand product on launch day in the US and to ship it to Germany as fast as possible. Despite all difficulties, they secured me the product one minute after the presale opened (it was 5AM in the US at that moment), carried me through all further steps to prepare and get the product delivered to Germany.',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/netherlands.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'TjadaL',
          },
          reviewBody:
            'Great! Recieved my fabrics etc in perfect state from Indonesia to the Netherlands. The Host (Salsabila) was very kind and updated me by every step. I absolutely will make use of this service again when needed :)',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/japan.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Jee',
          },
          reviewBody:
            'I’m in Japan and the size for the boots I needed to snowboard was sold out completely even in the states so I am very happy with my Shippn host who helped me get what I needed so I can go snowboarding! Fast, quick and easy process!',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/canada.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'James',
          },
          reviewBody:
            "I live in Canada and wanted an item on the Polish site, Allegro Lokalnie. Previously I had used another service which required delivery of the purchased item to their warehouse. But this new seller would only deliver to a locker box. So I found Shippn with a Google search and it worked out great! The Host picked up the item at a locker box and shipped it to me. Shippn's communications were superb. The estimated shipping costs were communicated in advance so I knew what I was getting into.",
        },
      ];
      const scriptElement = this.document.createElement('script');
      scriptElement.type = 'application/ld+json';
      scriptElement.textContent = JSON.stringify(reviewsData);
      scriptElement.id = 'reviewsScript';
      this.document.head.appendChild(scriptElement);
    }
  }
  removeReviewsSchema() {
    const scriptTags = document.querySelectorAll('script');
    scriptTags.forEach((script) => {
      if (
        script.id.includes('reviewHost') ||
        script.id.includes('reviewsScript')
      ) {
        this.document.head.removeChild(script);
      }
    });
  }
  createDynamicReviewsForHost(hostName, hostReviewData) {
    const hostReviewScriptID = `reviewHost-${hostName}`;

    if (window.document.getElementById(hostReviewScriptID)) {
      return;
    } else {
      const reviewsData = [
        {
          '@context': 'https://schema.org/',
          '@type': 'AggregateRating',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image:
              'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          ratingValue: '5',
          reviewCount: '7',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image:
              'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Nicholas',
          },
          reviewBody:
            "I didn't know such a service existed and when I found it, I was skeptical at first. But the whole process was seamless, the website was clear and informative and Stanislav (who collected and shipped the items) kept me up to date on every step. Got here quickly too. Very satisfied!",
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image:
              'https://www.shippn.com/assets/img/flags/united-states-of-america.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Anita',
          },
          reviewBody:
            "I'm a collector of a particular brand of product from around the world. Since discovering shippn two months ago, I've been able to shop for my favorite things in new markets such as Australia and South Africa. I've placed three orders with Shippn so far, and the fragile and hard to find items have all reached me quickly and in perfect condition. I've worked with two separate hosts on the three orders and both were a pleasure to work with and very responsive.",
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/belgium.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'A. Brahm',
          },
          reviewBody:
            "This is my 3rd experience with Shipping and it went marvelously as it was the case for my two former experiences with them. I trusted in the same host -- Mr. Kelby Cody -- and I'm so happy to have met him as a host. Kelby is such a great guy you can trust in. He always does the right thing, the fast and easy way. Kelby never forgets to get you updated about what's going on with your purchase. I really recommend Kelby and of course Shippn.",
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/united-kingdom.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Elaine',
          },
          reviewBody:
            'I was a little dubious to start with. But I could not find the item I wanted anywhere but Australia and they would not deliver to the UK. So I tried this service, fantastic. They kept me updated all the way through and I received my item in less than 2 weeks. I would definitely use them again.',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/germany.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Daniil',
          },
          reviewBody:
            'Absolutely great experience, top service - the best customer experience i have ever had. I came to Shippn with a very difficult task, to secure an expensive (4000 USD) high demand product on launch day in the US and to ship it to Germany as fast as possible. Despite all difficulties, they secured me the product one minute after the presale opened (it was 5AM in the US at that moment), carried me through all further steps to prepare and get the product delivered to Germany.',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/netherlands.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'TjadaL',
          },
          reviewBody:
            'Great! Recieved my fabrics etc in perfect state from Indonesia to the Netherlands. The Host (Salsabila) was very kind and updated me by every step. I absolutely will make use of this service again when needed :)',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/japan.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Jee',
          },
          reviewBody:
            'I’m in Japan and the size for the boots I needed to snowboard was sold out completely even in the states so I am very happy with my Shippn host who helped me get what I needed so I can go snowboarding! Fast, quick and easy process!',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@type': 'Organization',
            name: 'Shippn',
            image: 'https://www.shippn.com/assets/img/flags/canada.png',
            description: `Shop online from more than ${this.hostCountriesCount} countries and get it delivered to your doorstep! Sign up for free and start shopping from anywhere in the world with Shippn.`,
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'James',
          },
          reviewBody:
            "I live in Canada and wanted an item on the Polish site, Allegro Lokalnie. Previously I had used another service which required delivery of the purchased item to their warehouse. But this new seller would only deliver to a locker box. So I found Shippn with a Google search and it worked out great! The Host picked up the item at a locker box and shipped it to me. Shippn's communications were superb. The estimated shipping costs were communicated in advance so I knew what I was getting into.",
        },
      ];
      const scriptElement = this.document.createElement('script');
      scriptElement.type = 'application/ld+json';
      scriptElement.textContent = JSON.stringify(hostReviewData);
      scriptElement.id = hostReviewScriptID;
      this.document.head.appendChild(scriptElement);
    }
  }
  createMetaNoIndex() {
    const existingTag = this.document.head.querySelector(
      'meta[name="robots"][content="noindex"]'
    );
    if (!existingTag) {
      const metaTag = this.document.createElement('meta');
      metaTag.setAttribute('name', 'robots');
      metaTag.setAttribute('content', 'noindex');
      this.document.head.appendChild(metaTag);
    }
  }
  removeMetaNoIndex() {
    const metaTags = this.document.head.querySelectorAll('meta[name="robots"]');
    for (const tag of metaTags) {
      if (tag.getAttribute('content') === 'noindex') {
        this.document.head.removeChild(tag);
        break;
      }
    }
  }
  createCostCalculatorSchema() {
    if (window.document.getElementById('costCalculatorWebSchema')) {
      return;
    } else {
      const schemaData = {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'WebPage',
            '@id': `https://www.shippn.com//shipping-cost-calculator`,
            url: `https://www.shippn.com//shipping-cost-calculator`,
            name: 'Shipping Cost Calculator | Shippn',
            description:
              "Easily calculate international shipping costs using Shippn's shipping cost calculator. Get instant estimates for shipping from anywhere to your doorstep.",
            inLanguage: 'en',
            isPartOf: {
              '@type': 'WebSite',
              '@id': 'https://www.shippn.com/#website',
              name: 'Shippn',
              url: 'https://www.shippn.com',
            },
            breadcrumb: {
              '@id': `https://www.shippn.com//shipping-cost-calculator#breadcrumb`,
            },
          },
          {
            '@type': 'BreadcrumbList',
            '@id': `https://www.shippn.com//shipping-cost-calculator#breadcrumb`,
            itemListElement: [
              {
                '@type': 'ListItem',
                position: 1,
                name: 'Home',
                item: 'https://www.shippn.com/',
              },
              {
                '@type': 'ListItem',
                position: 2,
                name: 'Shipping Cost Calculator',
                item: `https://www.shippn.com//shipping-cost-calculator`,
              },
            ],
          },
          {
            '@type': 'SoftwareApplication',
            name: 'Shipping Cost Calculator',
            url: `https://www.shippn.com//shipping-cost-calculator`,
            applicationCategory: 'WebApplication',
            operatingSystem: 'All',
            offers: {
              '@type': 'Offer',
              price: '0',
              priceCurrency: 'USD',
              category: 'Free',
            },
            provider: {
              '@type': 'Organization',
              name: 'Shippn',
              url: 'https://www.shippn.com',
              logo: {
                '@type': 'ImageObject',
                url: 'https://d1we2hgzmci25y.cloudfront.net/assets/img/shippn-logo-black.webp',
              },
            },
          },
        ],
      };
      const scriptEl = window.document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.id = 'costCalculatorWebSchema';
      scriptEl.textContent = JSON.stringify(schemaData);
      this.document.head.appendChild(scriptEl);
    }
  }
  removeCostCalculatorSchema() {
    const costCalculatorSchemaScript = window.document.getElementById(
      'costCalculatorWebSchema'
    );
    if (costCalculatorSchemaScript) {
      window.document.head.removeChild(costCalculatorSchemaScript);
    }
  }


  crateCostCalculatorNewSchema() {
    if (window.document.getElementById('costCalculatorNewSchema')) {
      return;
    } else {
      const schemaData = {
        "@context": "https://schema.org",
        "@type": "WebApplication",
        "name": "Shippn International Shipping Cost Calculator",
        "applicationCategory": "BusinessApplication",
        "operatingSystem": "Web browser, Android, iOS",
        "offers": {
          "@type": "Offer",
          "price": "0",
          "priceCurrency": "USD"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "ratingCount": "256",
          "bestRating": "5",
          "worstRating": "1"
        },
        "description": "Calculate accurate international shipping costs across 39+ countries with Shippn's transparent and user-friendly shipping calculator. Compare rates, avoid hidden fees, and find affordable shipping options worldwide.",
        "featureList": [
          "Clear pricing with no hidden fees",
          "Real-time shipping estimates",
          "Global shipping to 39+ countries",
          "Customizable shipping options based on speed, weight, and preferences",
          "Competitive international shipping rates"
        ],
        "url": `https://www.shippn.com//shipping-cost-calculator`,
        "provider": {
          "@type": "Organization",
          "name": "Shippn",
          "description": "Shippn provides transparent, affordable international shipping services and solutions for individuals and businesses worldwide.",
          "url": "https://shippn.com"
        },
        "mainEntity": {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "How much does it cost to ship a package internationally?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The cost varies based on weight, dimensions, and destination. With Shippn, you can use our shipping cost calculator to get a quick, accurate estimate tailored to your needs. Shippn ensures transparent pricing, so you always know what to expect."
              }
            },
            {
              "@type": "Question",
              "name": "What is the difference between international shipping fees and postage costs?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Shipping fees often include additional charges like handling, customs, and packaging, while postage costs are specific to mailing services. Shippn simplifies this process by offering an all-inclusive pricing structure, so you can focus on your shopping and shipping without surprises."
              }
            },
            {
              "@type": "Question",
              "name": "How does Shippn compare with other services?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Shippn's competitive pricing, global reach, and customer-friendly policies make it the go-to choice for international shipping. Unlike other services, Shippn provides a seamless experience with accurate estimates, no hidden fees, and reliable delivery to 39+ countries."
              }
            },
            {
              "@type": "Question",
              "name": "Do I have to pay volumetric weight charges when shipping internationally?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Yes, volumetric weight charges apply when the package's size exceeds its actual weight. With Shippn, our calculator ensures you get the best possible rates, whether the cost is based on size or weight."
              }
            },
            {
              "@type": "Question",
              "name": "How can I estimate international shipping costs?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Simply input your package's details into Shippn's shipping cost calculator for an instant, accurate quote. This tool eliminates guesswork, helping you budget for your shipping needs."
              }
            },
            {
              "@type": "Question",
              "name": "What is the cheapest way to ship things internationally?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "The cheapest method depends on your package's specifics. With Shippn, you gain access to economy and standard shipping options, ensuring affordability without compromising reliability."
              }
            },
            {
              "@type": "Question",
              "name": "How much does it cost to ship something internationally?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "Shipping costs depend on factors like distance, weight, and size. Additional charges, such as customs fees, may also apply. With Shippn, you get transparent pricing and cost-effective options, making international shipping stress-free."
              }
            },
            {
              "@type": "Question",
              "name": "Is it cheaper to ship by weight or size?",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "It depends on the carrier's pricing structure. Shippn provides clarity by calculating costs based on actual or volumetric weight, ensuring you pay the most reasonable rate."
              }
            }
          ]
        }
      }

      const scriptEl = window.document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.id = 'costCalculatorNewSchema';
      scriptEl.textContent = JSON.stringify(schemaData);
      this.document.head.appendChild(scriptEl);
    }
  }
  removeCostCalculatorNewSchema() {
    const costCalculatorSchemaScript = window.document.getElementById(
      'costCalculatorNewSchema'
    );
    if (costCalculatorSchemaScript) {
      window.document.head.removeChild(costCalculatorSchemaScript);
    }
  }

  createHomePageSchema() {
    if (window.document.getElementById('homePageSchema')) {
      return;
    } else {
      const homePageSchema = {
        '@context': 'https://schema.org',
        '@graph': [
          {
            '@type': 'Organization',
            '@id': 'https://www.shippn.com/#organization',
            name: 'Shippn',
            url: `https://www.shippn.com//home`,
            logo: {
              '@type': 'ImageObject',
              url: 'https://d1we2hgzmci25y.cloudfront.net/assets/img/shippn-logo-black.webp',
              width: 199,
              height: 47,
            },
            address: {
              '@type': 'PostalAddress',
              streetAddress: '8 The Green Ste 4000',
              addressLocality: 'Dover',
              addressRegion: 'DE',
              postalCode: '19901',
              addressCountry: 'US',
            },
            email: 'help@shippn.com',
            telephone: '1-740-848-5020',
            sameAs: [
              'https://www.instagram.com/shippncom/',
              'https://www.facebook.com/shippn',
              'https://x.com/shippncom',
              'https://www.linkedin.com/company/shippn/',
            ],
            description:
              'Shippn is a trusted community marketplace for people to shop from anywhere in the world, providing local addresses in over 40 countries and express delivery in 1-5 days.',
          },
          {
            '@type': 'WebSite',
            '@id': 'https://www.shippn.com/#website',
            url: `https://www.shippn.com//home`,
            name: 'Shippn - Shop Globally, Receive Locally',
            publisher: {
              '@id': 'https://www.shippn.com/#organization',
            },
            potentialAction: {
              '@type': 'OrderAction',
              target: `https://www.shippn.com//bfm`,
              name: 'Place an Order',
            },
          },
          {
            '@type': 'WebPage',
            '@id': `https://www.shippn.com//home`,
            url: `https://www.shippn.com//home`,
            name: 'Shippn - Global Shopping Made Easy | Shop From 40+ Countries',
            isPartOf: {
              '@id': 'https://www.shippn.com/#website',
            },
            about: {
              '@id': 'https://www.shippn.com/#organization',
            },
            description:
              "Shop online from more than 40 countries and receive your packages with express delivery in 1-5 days with Shippn's global shopping service.",
          },
          {
            '@type': 'Service',
            name: 'Global Shopping Service',
            provider: {
              '@id': 'https://www.shippn.com/#organization',
            },
            description:
              'Shippn provides local addresses in over 40 countries, allowing shoppers to purchase items internationally and receive them via express delivery in 1-5 days.',
            areaServed: {
              '@type': 'Country',
              name: 'Worldwide',
            },
            hasOfferCatalog: {
              '@type': 'OfferCatalog',
              name: 'Shippn Services',
              itemListElement: [
                {
                  '@type': 'Offer',
                  itemOffered: {
                    '@type': 'Service',
                    name: 'Address Hosting',
                    description:
                      'Get a local address in over 40 countries for your online shopping',
                  },
                },
                {
                  '@type': 'Offer',
                  itemOffered: {
                    '@type': 'Service',
                    name: 'Express Shipping',
                    description:
                      'Receive your international packages in 1-5 days',
                  },
                },
                {
                  '@type': 'Offer',
                  itemOffered: {
                    '@type': 'Service',
                    name: 'Package Forwarding',
                    description:
                      'Forward your packages from multiple countries to your doorstep',
                  },
                },
              ],
            },
          },
          {
            '@type': 'AggregateRating',
            itemReviewed: {
              '@id': 'https://www.shippn.com/#organization',
            },
            ratingValue: '4.9',
            bestRating: '5',
            worstRating: '1',
            ratingCount: '8',
            description:
              "Customer reviews for Shippn's global shopping service",
          },
          {
            '@type': 'FAQPage',
            mainEntity: [
              {
                '@type': 'Question',
                name: 'What is Shippn?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'Shippn is a trusted community marketplace for people to shop from anywhere in the world. Shippn hosts help shoppers from all around the world to have a local address in every country and shop conveniently like there are no borders.',
                },
              },
              {
                '@type': 'Question',
                name: 'How many countries can I shop from with Shippn?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: 'With Shippn, you can shop online from more than 40 countries in the world and receive your items with express delivery in 1-5 days after our hosts receive your packages regardless of where you live.',
                },
              },
              {
                '@type': 'Question',
                name: 'How does Shippn ship packages?',
                acceptedAnswer: {
                  '@type': 'Answer',
                  text: "Shippn works with worldwide trusted logistics partners like DHL, TNT, UPS, FEDEX and picks the best partner to deliver to members' door fast and secure.",
                },
              },
            ],
          },
          {
            '@context': 'https://schema.org/',
            '@type': 'Review',
            itemReviewed: {
              '@id': 'https://www.shippn.com/#organization',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: '5',
              bestRating: '5',
            },
            author: {
              '@type': 'Person',
              name: 'Nicholas',
            },
            reviewBody:
              "I didn't know such a service existed and when I found it, I was skeptical at first. But the whole process was seamless, the website was clear and informative and Stanislav (who collected and shipped the items) kept me up to date on every step. Got here quickly too. Very satisfied!",
          },
          {
            '@context': 'https://schema.org/',
            '@type': 'Review',
            itemReviewed: {
              '@id': 'https://www.shippn.com/#organization',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: '5',
              bestRating: '5',
            },
            author: {
              '@type': 'Person',
              name: 'Anita',
            },
            reviewBody:
              "I'm a collector of a particular brand of product from around the world. Since discovering shippn two months ago, I've been able to shop for my favorite things in new markets such as Australia and South Africa. I've placed three orders with Shippn so far, and the fragile and hard to find items have all reached me quickly and in perfect condition. I've worked with two separate hosts on the three orders and both were a pleasure to work with and very responsive.",
          },
          {
            '@context': 'https://schema.org/',
            '@type': 'Review',
            itemReviewed: {
              '@id': 'https://www.shippn.com/#organization',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: '5',
              bestRating: '5',
            },
            author: {
              '@type': 'Person',
              name: 'A. Brahm',
            },
            reviewBody:
              "This is my 3rd experience with Shipping and it went marvelously as it was the case for my two former experiences with them. I trusted in the same host -- Mr. Kelby Cody -- and I'm so happy to have met him as a host. Kelby is such a great guy you can trust in. He always does the right thing, the fast and easy way. Kelby never forgets to get you updated about what's going on with your purchase. I really recommend Kelby and of course Shippn.",
          },
          {
            '@context': 'https://schema.org/',
            '@type': 'Review',
            itemReviewed: {
              '@id': 'https://www.shippn.com/#organization',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: '5',
              bestRating: '5',
            },
            author: {
              '@type': 'Person',
              name: 'Elaine',
            },
            reviewBody:
              'I was a little dubious to start with. But I could not find the item I wanted anywhere but Australia and they would not deliver to the UK. So I tried this service, fantastic. They kept me updated all the way through and I received my item in less than 2 weeks. I would definitely use them again.',
          },
          {
            '@context': 'https://schema.org/',
            '@type': 'Review',
            itemReviewed: {
              '@id': 'https://www.shippn.com/#organization',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: '5',
              bestRating: '5',
            },
            author: {
              '@type': 'Person',
              name: 'Daniil',
            },
            reviewBody:
              'Absolutely great experience, top service - the best customer experience i have ever had. I came to Shippn with a very difficult task, to secure an expensive (4000 USD) high demand product on launch day in the US and to ship it to Germany as fast as possible. Despite all difficulties, they secured me the product one minute after the presale opened (it was 5AM in the US at that moment), carried me through all further steps to prepare and get the product delivered to Germany.',
          },
          {
            '@context': 'https://schema.org/',
            '@type': 'Review',
            itemReviewed: {
              '@id': 'https://www.shippn.com/#organization',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: '5',
              bestRating: '5',
            },
            author: {
              '@type': 'Person',
              name: 'TjadaL',
            },
            reviewBody:
              'Great! Recieved my fabrics etc in perfect state from Indonesia to the Netherlands. The Host (Salsabila) was very kind and updated me by every step. I absolutely will make use of this service again when needed :)',
          },
          {
            '@context': 'https://schema.org/',
            '@type': 'Review',
            itemReviewed: {
              '@id': 'https://www.shippn.com/#organization',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: '5',
              bestRating: '5',
            },
            author: {
              '@type': 'Person',
              name: 'Jee',
            },
            reviewBody:
              'I’m in Japan and the size for the boots I needed to snowboard was sold out completely even in the states so I am very happy with my Shippn host who helped me get what I needed so I can go snowboarding! Fast, quick and easy process!',
          },
          {
            '@context': 'https://schema.org/',
            '@type': 'Review',
            itemReviewed: {
              '@id': 'https://www.shippn.com/#organization',
            },
            reviewRating: {
              '@type': 'Rating',
              ratingValue: '5',
              bestRating: '5',
            },
            author: {
              '@type': 'Person',
              name: 'James',
            },
            reviewBody:
              "I live in Canada and wanted an item on the Polish site, Allegro Lokalnie. Previously I had used another service which required delivery of the purchased item to their warehouse. But this new seller would only deliver to a locker box. So I found Shippn with a Google search and it worked out great! The Host picked up the item at a locker box and shipped it to me. Shippn's communications were superb. The estimated shipping costs were communicated in advance so I knew what I was getting into.",
          },
        ],
      };
      const scriptEl = window.document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.id = 'homePageSchema';
      scriptEl.textContent = JSON.stringify(homePageSchema);
      this.document.head.appendChild(scriptEl);
    }
  }

  removeHomePageSchema() {
    const homePageSchemaScript =
      window.document.getElementById('homePageSchema');
    if (homePageSchemaScript) {
      window.document.head.removeChild(homePageSchemaScript);
    }
  }


  createB2BContactUsPageSchema() {
    if (window.document.getElementById('b2bContactUsPageSchema')) {
      return;
    } else {

      const mainSchemaData = {
        "@context": "https://schema.org",
        '@graph': [{
          "@type": "Service",
          "name": "Shippn Business Shipping Solutions",
          "description": "Ship Worldwide with Confidence. Save 60% on shipping and create your labels in minutes with top-rated carriers.",
          "url": "https://www.shippn.com/en/b2b/contactus",
          "logo": "https://www.shippn.com/assets/img/logo.png",
          "serviceType": "International Package Shipping",
          "provider": {
            "@type": "Organization",
            "name": "Shippn",
            "logo": "https://d1we2hgzmci25y.cloudfront.net/assets/img/shippn-logo-black.webp",
            "sameAs": [
              "https://www.facebook.com/ShippnGlobal",
              "https://twitter.com/ShippnGlobal",
              "https://www.instagram.com/shippnglobal/",
              "https://www.linkedin.com/company/shippn/"
            ],
            "brand": {
              "@type": "Brand",
              "name": "Shippn"
            },
            "contactPoint": {
              "@type": "ContactPoint",
              "contactType": "customer service",
              "email": "support@shippn.com",
              "url": "https://www.shippn.com/contact-us",
              "telephone": "+1-740-848-5020"
            }
          },
          "offers": {
            "@type": "Offer",
            "description": "Save 60% on shipping and create your labels in minutes with top-rated carriers!",
            "availability": "https://schema.org/InStock",
            "priceCurrency": "USD",
            "itemOffered": {
              "@type": "Service",
              "name": "Express International Shipping",
              "description": "Swift delivery within 1–5 days for international orders",
              "areaServed": {
                "@type": "Country",
                "name": "Worldwide"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.8",
                "reviewCount": "1250"
              },
              "review": [
                {
                  "@type": "Review",
                  "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "bestRating": "5"
                  },
                  "author": {
                    "@type": "Person",
                    "name": "Customer 1"
                  },
                  "reviewBody": "Effortless shipping process. My package arrived across the world in just 3 days!"
                },
                {
                  "@type": "Review",
                  "reviewRating": {
                    "@type": "Rating",
                    "ratingValue": "5",
                    "bestRating": "5"
                  },
                  "author": {
                    "@type": "Person",
                    "name": "Customer 2"
                  },
                  "reviewBody": "Competitive rates and excellent service. Will definitely use Shippn again!"
                }
              ]
            }
          },
          "mainEntityOfPage": {
            "@type": "WebPage",
            "name": "Business Shipping Contact Page",
            "url": "https://www.shippn.com/en/b2b/contactus",
            "lastReviewed": "2025-05-16"
          },
        },
        {
          '@type': 'WebPage',
          '@id': `https://www.shippn.com//b2b/contactus`,
          url: `https://www.shippn.com//b2b/contactus`,
          name: 'Worldwide Shipping Service | Shop Anywhere, Ship Everywhere - Shippn',
          isPartOf: {
            '@id': 'https://www.shippn.com/#website',
          },
          about: {
            '@id': 'https://www.shippn.com/#organization',
          },
          description:
            "Simplify your international shipping process with Shippn. Ship your products globally, connect your business with your customers worldwide.",
        },
        {
          '@type': 'AggregateRating',
          itemReviewed: {
            '@id': 'https://www.shippn.com/#organization',
          },
          ratingValue: '4.9',
          bestRating: '5',
          worstRating: '1',
          ratingCount: '8',
          description:
            "Customer reviews for Shippn's global shopping service",
        },
        {
          '@type': 'FAQPage',
          mainEntity: [
            {
              '@type': 'Question',
              name: 'What is Shippn?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'Shippn is a trusted community marketplace for people to shop from anywhere in the world. Shippn hosts help shoppers from all around the world to have a local address in every country and shop conveniently like there are no borders.',
              },
            },
            {
              '@type': 'Question',
              name: 'How many countries can I shop from with Shippn?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: 'With Shippn, you can shop online from more than 40 countries in the world and receive your items with express delivery in 1-5 days after our hosts receive your packages regardless of where you live.',
              },
            },
            {
              '@type': 'Question',
              name: 'How does Shippn ship packages?',
              acceptedAnswer: {
                '@type': 'Answer',
                text: "Shippn works with worldwide trusted logistics partners like DHL, TNT, UPS, FEDEX and picks the best partner to deliver to members' door fast and secure.",
              },
            },
          ],
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@id': 'https://www.shippn.com/#organization',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Nicholas',
          },
          reviewBody:
            "I didn't know such a service existed and when I found it, I was skeptical at first. But the whole process was seamless, the website was clear and informative and Stanislav (who collected and shipped the items) kept me up to date on every step. Got here quickly too. Very satisfied!",
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@id': 'https://www.shippn.com/#organization',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Anita',
          },
          reviewBody:
            "I'm a collector of a particular brand of product from around the world. Since discovering shippn two months ago, I've been able to shop for my favorite things in new markets such as Australia and South Africa. I've placed three orders with Shippn so far, and the fragile and hard to find items have all reached me quickly and in perfect condition. I've worked with two separate hosts on the three orders and both were a pleasure to work with and very responsive.",
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@id': 'https://www.shippn.com/#organization',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'A. Brahm',
          },
          reviewBody:
            "This is my 3rd experience with Shipping and it went marvelously as it was the case for my two former experiences with them. I trusted in the same host -- Mr. Kelby Cody -- and I'm so happy to have met him as a host. Kelby is such a great guy you can trust in. He always does the right thing, the fast and easy way. Kelby never forgets to get you updated about what's going on with your purchase. I really recommend Kelby and of course Shippn.",
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@id': 'https://www.shippn.com/#organization',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Elaine',
          },
          reviewBody:
            'I was a little dubious to start with. But I could not find the item I wanted anywhere but Australia and they would not deliver to the UK. So I tried this service, fantastic. They kept me updated all the way through and I received my item in less than 2 weeks. I would definitely use them again.',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@id': 'https://www.shippn.com/#organization',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Daniil',
          },
          reviewBody:
            'Absolutely great experience, top service - the best customer experience i have ever had. I came to Shippn with a very difficult task, to secure an expensive (4000 USD) high demand product on launch day in the US and to ship it to Germany as fast as possible. Despite all difficulties, they secured me the product one minute after the presale opened (it was 5AM in the US at that moment), carried me through all further steps to prepare and get the product delivered to Germany.',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@id': 'https://www.shippn.com/#organization',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'TjadaL',
          },
          reviewBody:
            'Great! Recieved my fabrics etc in perfect state from Indonesia to the Netherlands. The Host (Salsabila) was very kind and updated me by every step. I absolutely will make use of this service again when needed :)',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@id': 'https://www.shippn.com/#organization',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'Jee',
          },
          reviewBody:
            'I’m in Japan and the size for the boots I needed to snowboard was sold out completely even in the states so I am very happy with my Shippn host who helped me get what I needed so I can go snowboarding! Fast, quick and easy process!',
        },
        {
          '@context': 'https://schema.org/',
          '@type': 'Review',
          itemReviewed: {
            '@id': 'https://www.shippn.com/#organization',
          },
          reviewRating: {
            '@type': 'Rating',
            ratingValue: '5',
            bestRating: '5',
          },
          author: {
            '@type': 'Person',
            name: 'James',
          },
          reviewBody:
            "I live in Canada and wanted an item on the Polish site, Allegro Lokalnie. Previously I had used another service which required delivery of the purchased item to their warehouse. But this new seller would only deliver to a locker box. So I found Shippn with a Google search and it worked out great! The Host picked up the item at a locker box and shipped it to me. Shippn's communications were superb. The estimated shipping costs were communicated in advance so I knew what I was getting into.",
        }
        ]


      };
      const faqSchemaData =
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "mainEntity": [
          {
            "@type": "Question",
            "name": "How does Shippn's service work?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Shippn makes international shipping easy. Simply enter your package details (origin, destination, dimensions, and weight), get instant quotes from top carriers, select your preferred service, and create shipping labels in minutes. Your package can be picked up or dropped off at a carrier location."
            }
          },
          {
            "@type": "Question",
            "name": "How much can I save with Shippn?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Our customers save up to 60% on international shipping through our strategic partnerships with leading carriers like DHL, FedEx, UPS, TNT Express, La Poste, and Australia Post."
            }
          },
          {
            "@type": "Question",
            "name": "How long does international delivery take?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "With Shippn, your international customers can receive their orders within 1-5 business days, depending on the destination country and service level selected."
            }
          },
          {
            "@type": "Question",
            "name": "Which countries does Shippn serve?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Shippn provides shipping services to more than 35 countries worldwide. You can check specific routes and rates by using our shipping calculator on the website."
            }
          },
          {
            "@type": "Question",
            "name": "Which carriers does Shippn partner with?",
            "acceptedAnswer": {
              "@type": "Answer",
              "text": "Shippn partners with leading global carriers including DHL, FedEx, UPS, TNT Express, La Poste, Australia Post, USPS, Aramex, EMS, DPD, and Evri."
            }
          }
        ]
      };
      const productSchemaData =
      {
        "@context": "https://schema.org",
        "@type": "Product",
        "name": "International Shipping Services",
        "image": "https://www.shippn.com/assets/img/product/shipping-service.jpg",
        "description": "Save 60% on international shipping and create your labels in minutes with top-rated carriers including DHL, FedEx, UPS, and more.",
        "brand": {
          "@type": "Brand",
          "name": "Shippn"
        },
        "offers": {
          "@type": "AggregateOffer",
          "highPrice": "200",
          "lowPrice": "15",
          "priceCurrency": "USD",
          "offerCount": "50+",
          "availability": "https://schema.org/InStock"
        },
        "aggregateRating": {
          "@type": "AggregateRating",
          "ratingValue": "4.8",
          "reviewCount": "1250"
        }
      };
      const breadcrumbSchemaData = {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          {
            "@type": "ListItem",
            "position": 1,
            "name": "Home",
            "item": "https://www.shippn.com/en/"
          },
          {
            "@type": "ListItem",
            "position": 2,
            "name": "Business Solutions",
            "item": "https://www.shippn.com/en/b2b/"
          },
          {
            "@type": "ListItem",
            "position": 3,
            "name": "Contact Us",
            "item": "https://www.shippn.com/en/b2b/contactus"
          }
        ]
      };

      const scriptEl = window.document.createElement('script');
      scriptEl.type = 'application/ld+json';
      scriptEl.id = 'b2bContactUsPageSchema';
      scriptEl.textContent = JSON.stringify(mainSchemaData);
      this.document.head.appendChild(scriptEl);

      const scriptElFaq = window.document.createElement('script');
      scriptElFaq.type = 'application/ld+json';
      scriptElFaq.id = 'b2bContactUsPageSchemaFaq';
      scriptElFaq.textContent = JSON.stringify(faqSchemaData);
      this.document.head.appendChild(scriptElFaq);

      const scriptElProduct = window.document.createElement('script');
      scriptElProduct.type = 'application/ld+json';
      scriptElProduct.id = 'b2bContactUsPageSchemaProduct';
      scriptElProduct.textContent = JSON.stringify(productSchemaData);
      this.document.head.appendChild(scriptElProduct);

      const scriptElBreadcrumb = window.document.createElement('script');
      scriptElBreadcrumb.type = 'application/ld+json';
      scriptElBreadcrumb.id = 'b2bContactUsPageSchemaBreadcrumb';
      scriptElBreadcrumb.textContent = JSON.stringify(breadcrumbSchemaData);
      this.document.head.appendChild(scriptElBreadcrumb);

    }
  }
  removeB2BContactUsPageSchema() {
    const scriptEl = window.document.getElementById('b2bContactUsPageSchema');
    if (scriptEl) {
      window.document.head.removeChild(scriptEl);
    }
    const scriptElFaq = window.document.getElementById('b2bContactUsPageSchemaFaq');
    if (scriptElFaq) {
      window.document.head.removeChild(scriptElFaq);
    }
    const scriptElProduct = window.document.getElementById('b2bContactUsPageSchemaProduct');
    if (scriptElProduct) {
      window.document.head.removeChild(scriptElProduct);
    }
    const scriptElBreadcrumb = window.document.getElementById('b2bContactUsPageSchemaBreadcrumb');
    if (scriptElBreadcrumb) {
      window.document.head.removeChild(scriptElBreadcrumb);
    }
  }
}